import React from "react";
import ProgressBar from "../../../../form/ProgressBar";
import {ProductColumn} from "../../../../../utils/formatters";
import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";

export default class Progress extends React.Component {

    loadProgress = () => {
        this.items && this.items.refreshBackground();
    }

    render() {
        return (
            <SelectorGrid
                ref={(e) => this.items = e}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", params: {name: ((this.props.values.label ? this.props.values.label + " - " : "") + "Eltérések")}}]}
                {...this.props.props.pool}
                parameters={{...this.props.props.pool.parameters}}
                aggregations={{
                    fields: {
                        "qty": {
                            field: "qty", type: "SUM"
                        },
                        "stockqty": {
                            field: "stockqty", type: "SUM"
                        }
                    }
                }}
                columns={{
                    "displayname": {
                        ...ProductColumn("component_id"),
                    },
                }}
                type={(props) => <ProgressBar
                    min={0}
                    max={((props.aggregationRows || [])[0] || {}).stockqty || 0}
                    now={((props.aggregationRows || [])[0] || {}).qty || 0}
                    style={{minWidth: ((props.aggregationRows || [])[0] || {}).qty || 0 > 0 ? '140px' : 0}}
                    label={`${((props.aggregationRows || [])[0] || {}).qty || 0} db / ${((props.aggregationRows || [])[0] || {}).stockqty || 0} db`}
                />}
            />
        );
    }
}